<template>
  <div class="voucher">
    <el-drawer
      size="580px"
      custom-class="detailDialog"
      :data="visible"
      :visible.sync="visible"
      :before-close="cancelModal"
      title="付款凭证"
    >
      <!-- <span slot="title" class="drawer-title">
        <el-button
          type="primary"
          size="small"
          :loading="btnLoading"
          @click="printPDF"
          >下载PDF打印</el-button
        >
      </span> -->

      <div
        ref="print"
        class="print"
        id="print"
        v-if="detailList && detailList.length > 0"
      >
        <div>
          <div class="voucher" v-for="(item, index) in detailList" :key="index">
            <img
              :src="item.img"
              alt=""
              width="400"
              height="250"
              style="position: absolute; right: -110px; bottom: 16px"
            />
            <div class="lists">
              <div class="title">
                <img src="@/static/zflogo.png" alt="" />
                <div class="center">付款凭证</div>
                
              </div>
              <div class="money">
                <div class="left">
                  <div class="label"><div>交易金额：{{ item.tranAmount }} 元</div><div>交易类型：支付</div></div>
                  <div class="val">
                     (大写：{{
                      digitUppercase(item.tranAmount)
                    }})
                  </div>
                </div>
                <!-- <div class="right">
                  <div class="label"></div>
                  <div class="val"></div>
                </div> -->
              </div>
              <div class="info">
                <div class="info-title">
                  <div class="left">付款信息</div>
                  <div class="right">收款信息</div>
                </div>
                <div class="info-content">
                  <div class="blocks">
                    <div class="block">
                      <div class="left">付款公司: {{ item.companyName }}</div>
                      <!-- <div class="right">
                       
                      </div> -->
                    </div>
                    <div class="block">
                      <div class="left">收款人: {{ item.payeeName }}</div>
                      <!-- <div class="right">
                       
                      </div> -->
                    </div>
                    <div class="block">
                      <div class="left">项目名称: {{ item.projectInfoName }}</div>
                      <!-- <div class="right">
                        
                      </div> -->
                    </div>
                    <div class="block">
                      <div class="left">收款账号: {{ item.bindingBankNo }}</div>
                      <!-- <div class="right">
                       
                      </div> -->
                    </div>
                    <div class="block">
                      <div class="left">付款运单总数(车): {{ item.waybillCnt }}</div>
                      <!-- <div class="right">
                        -->
                      <!-- </div> -->
                    </div>
                    <div class="block">
                      <div class="left">收款银行: {{ item.bindingBankName }}</div>
                      <!-- <div class="right">
                       
                      </div> -->
                    </div>
                    <div class="block">
                      <div class="left">支付单号: {{ item.paymentNo }}</div>
                      <!-- <div class="right">
                       
                      </div> -->
                    </div>
                    <!-- {{ item.paymentNo }} -->
                    <div class="block">
                      <div class="left">付款时间: {{
                    $moment(item.payTime).format("YYYY-MM-DD HH:mm:ss")
                  }}</div>
                      <!-- <div class="right">
                       
                      </div> -->
                    </div>
                  </div>
                </div>
                <!-- <div class="no">
                  <div class="right">
                  付款时间：
                </div> -->
                <!-- </div> -->
              </div>

              <!-- <ul>
                <li>
                  <el-row>
                    <el-col :span="12"> 交易类型：支付 </el-col>
                    <el-col :span="12"> 支付单号：{{ item.paymentNo }} </el-col>
                  </el-row>
                </li>
                <li>
                  <el-row>
                    <el-col :span="12">
                      项目名称：{{ item.projectInfoName }}
                    </el-col>
                    <el-col :span="12">
                      付款运单总数：{{ item.waybillCnt }}车
                    </el-col>
                  </el-row>
                </li>
                <li>
                  <el-row>
                    <el-col :span="12">
                      交易金额：{{ item.tranAmount }}元
                    </el-col>
                    <el-col :span="12">
                      收款卡号：{{ item.bindingBankNo }}
                    </el-col>
                  </el-row>
                </li>
                <li>
                  <el-row>
                    <el-col :span="12">
                      收款人姓名：{{ item.payeeName }}
                    </el-col>
                    <el-col :span="12">
                      收款银行：{{ item.bindingBankName }}
                    </el-col>
                  </el-row>
                </li>
                <li>
                  <el-row>
                    <el-col :span="24">
                      付款公司：{{ item.companyName }}
                    </el-col>
                  </el-row>
                </li>
                <li>
                  <el-row>
                    <el-col :span="12">
                      创建时间：{{ item.createDatetime }}
                    </el-col>
                    <el-col :span="12">
                      付款时间：{{
                        $moment(item.payTime).format("YYYY-MM-DD HH:mm:ss")
                      }}
                    </el-col>
                  </el-row>
                </li>
              </ul> -->
            </div>
          </div>
        </div>
      </div>
      <el-empty v-else></el-empty>
      <div class="oper">
        <el-button
          type="primary"
          size="small"
          plain
          :loading="btnLoading"
          @click="printPDF"
          >下载PDF</el-button
        >
        <div class="btns" @click="cancelModal">
          <div class="left">取消</div>
          <div class="right">确定</div>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { getEvidenceWherePdf } from "@/api/chain/companyauthrecharge";
import { print, downloadPDF } from "@/util/util.js";
import { expotOut } from "@/util/down.js";

export default {
  props: {
    //弹窗状态
    visible: {
      type: Boolean,
      default: false,
    },
    detailList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    paymentIdList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    sourceId: {
      type: [String, Boolean],
      default: () => {
        return false;
      },
    },
  },
  data() {
    return {
      btnLoading: false,
    };
  },
  created() {},
  mounted: function () {
    console.log(this.paymentIdList);
  },
  computed: {
    ...mapGetters(["permissions"]),
  },
  methods: {
    digitUppercase(n) {
      var fraction = ["角", "分"];
      var digit = ["零", "壹", "贰", "叁", "肆", "伍", "陆", "柒", "捌", "玖"];
      var unit = [
        ["元", "万", "亿"],
        ["", "拾", "佰", "仟"],
      ];
      var head = n < 0 ? "欠" : "";
      n = Math.abs(n);
      var s = "";
      for (var i = 0; i < fraction.length; i++) {
        s += (
          digit[Math.floor(n * 10 * Math.pow(10, i)) % 10] + fraction[i]
        ).replace(/零./, "");
      }
      s = s || "整";
      n = Math.floor(n);
      for (var i = 0; i < unit[0].length && n > 0; i++) {
        var p = "";
        for (var j = 0; j < unit[1].length && n > 0; j++) {
          p = digit[n % 10] + unit[1][j] + p;
          n = Math.floor(n / 10);
        }
        s = p.replace(/(零.)*零$/, "").replace(/^$/, "零") + unit[0][i] + s;
      }
      return (
        head +
        s
          .replace(/(零.)*零元/, "元")
          .replace(/(零.)+/g, "零")
          .replace(/^整$/, "零元整")
      );
    },
    cancelModal() {
      this.$emit("update:visible", false);
      this.$emit("refreshChange");
    },
    print() {
      print(this.$refs.print);
    },
    printPDF() {
      this.btnLoading = true;
      console.log(this.paymentIdList);
      let param = {
        paymentIdList: this.paymentIdList,
      };
      //钱包查询凭证
      if (this.sourceId) {
        param = {
          sourceId: this.sourceId,
        };
      }
      getEvidenceWherePdf(param)
        .then((res) => {
          console.log(res);
          const url = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement("a");
          link.href = url;
          let fileName = "凭证.pdf"; //
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
          this.btnLoading = false;
        })
        .catch((err) => {
          this.btnLoading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-drawer__body {
  padding: 0 !important;
}
.oper {
  position: absolute;
  bottom: 0;
  right: 0;
  left: 0;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 64px;
  border-top: 1px solid #999999;
  padding:0 24px;
  .down {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 74px;
    height: 32px;
    background: #ffffff;
    border-radius: 3px;
    border: 1px solid #35b1ff;
    font-weight: 400;
    font-size: 14px;
    color: #35b1ff;
  }
  .btns {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .left {
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: 400;
      font-size: 14px;
      color: #313133;
      width: 74px;
      height: 32px;
      background: #ffffff;
      border-radius: 3px;
      border: 1px solid #999999;
      margin-right: 16px;
    }
    .right {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 74px;
      height: 32px;
      background: #35b1ff;
      box-shadow: 0px 0px 1px 0px rgba(0, 27, 102, 0.08),
        0px 1px 3px -1px rgba(0, 42, 140, 0.08),
        0px 2px 7px -2px rgba(0, 27, 102, 0.08);
      border-radius: 3px;
      font-weight: 400;
      font-size: 14px;
      color: #ffffff;
    }
  }
}
/deep/ .el-drawer__header {
  padding: 11px 20px;
  border-bottom: 2px solid #999999;
}
.no {
  padding:0 20px;
  display: flex;
  align-items: center;
  // width: 50%;
  // justify-content: space-between;
  height: 48px;
  font-weight: 500;
      font-size: 14px;
      color: #313133;
      .right{
        width: 50%;
      }
}
.info {
  .info-title {
    display: flex;
    align-items: center;
    height: 47px;
    // border-bottom: 1px solid #999999;
    .left,
    .right {
      margin-left: 20px;
      width: 50%;
      font-weight: 500;
      font-size: 14px;
      color: #313133;
    }
  }
  .info-content {
    .blocks {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      .block {
        display: flex;
        align-items: center;
        width: 50%;
        // border-bottom: 1px solid #999999;
        &:nth-child(2n) {
          .right {
            border-right: none;
          }
        }
        .left {
          height: 48px;
          display: flex;
          align-items: center;
          padding-left: 20px;
          // background: #f5f8fa;
          // box-shadow: 0px 1px 0px 0px #999999;
          // width: 38%;
         font-weight: 500;
      font-size: 14px;
      color: #313133;
          // border-right: 1px solid #999999;
        }
        .right {
          height: 48px;
          display: flex;
          align-items: center;
          padding-left: 20px;
          width: 62%;
          font-weight: 400;
          font-size: 14px;
          color: #313133;
          // border-right: 1px solid #999999;
        }
      }
    }
  }
}
/deep/ .detailDialog {
  .avue-crud__menu {
    display: none;
  }
  .lists {

   border: 2px solid hsl(0, 0%, 60%);
    // padding: 10px 0px;
    font-size: 12px;

    .title {
      position: relative;
      padding: 0 12px;
      text-align: center;
      height: 65px;
      line-height: 65px;
      // display: flex;
      // align-items: center;
      // justify-content: space-between;
      font-size: 16px;
      color: #111528;
      // border-left: 4px solid #4688f7;
      // margin-bottom: 20px;
      // padding-bottom: 10px;
      border-bottom: 2px solid #999999;
      img {
        position: absolute;
        left: 12px;
        top: 50%;
        transform: translateY(-50%);
        width: 78px;
        height: 28px;
      }
      .center {
        font-weight: 500;
        font-size: 20px;
        color: #313133;
      }
      .right {
        width: 38%;
        font-weight: 400;
        font-size: 14px;
        color: #313133;
      }
      span {
        display: inline-block;
        height: 16px;
        width: 4px;
        background-color: #4688f7;
        margin-right: 4px;
      }
    }
    ul {
      padding: 0px 30px;
      li {
        line-height: 30px;
        color: #303133;
      }
    }
  }
  .el-drawer__header {
    margin-bottom: 0;
  }
  .el-drawer__body {

    padding: 0px 20px;
    .voucher {
      // transform: scale(.8);
      zoom: .8;

      position: relative;
      padding-bottom: 20px;
      &:nth-of-type(3n) {
        margin-bottom: 20px;
      }
    }
  }
  // .detailContent{
  .print {

    padding: 30px 30px 0px;
    position: relative;
    left: 0;
    top: 0;
    margin-bottom: 64px;
    // border-top: 1px solid #999999;
  }

  // }
}
.money {
  height: 93px;
  // verticle-align:middle ;
  display: flex;
  align-items: center;
  // justify-content: space-between;
  // padding: 0 20px;
  border-bottom: 2px solid #999999;
  .left{
    width: 100%;
  }
  .left,
  .right {
    .label {
      font-weight: 400;
      font-size: 14px;
      color: #313133;
    }
    .val {
       padding-left: 20px;
      margin-top: 10px;
      font-weight: 400;
      font-size: 18px;
      color: #313133;
    }
  }
  .right {
    width: 38%;
  }
  .left{
   .label{
     display: flex;
    align-items: center;
    justify-content: space-between;
    div{
      width: 50%;
        padding-left: 20px;
    }
   }
  }
}
</style>
